<template>
  <div class="flex h-full max-h-full min-h-0 flex-col">
    <div class="shrink-0 px-4 pt-2">
      <BaseSimpleTab :tabs="tabs" />
    </div>
    <div class="flex min-h-0 flex-1 flex-col">
      <RouterView />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheItemInfoPage',
  data() {
    return {
      tabs: [
        {
          label: this.$t('global.general_information'),
          icon: 'info-square',
          routeName: 'settings_edit_item_route'
        },
        {
          label: this.$t('global.activities'),
          icon: 'file-alt',
          routeName: 'settings_item_activity_route'
        }
      ]
    }
  }
}
</script>
